import { render, staticRenderFns } from "./DictEdit.vue?vue&type=template&id=37ecd456&scoped=true"
import script from "./DictEdit.vue?vue&type=script&lang=js"
export * from "./DictEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ecd456",
  null
  
)

export default component.exports